import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/common/Button';

const PluginNotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary-50">
      <div className="text-center max-w-md px-6">
        <div className="text-6xl mb-4">🔌</div>
        <h1 className="text-3xl font-bold text-secondary-900 mb-4">
          Plugin Not Found
        </h1>
        <p className="text-secondary-600 mb-8">
          The requested plugin is not available or has not been implemented yet.
        </p>
        <Button
          title="Go Back"
          onClick={() => navigate(-1)}
          variant="primary"
          fullWidth={false}
        />
      </div>
    </div>
  );
};

export default PluginNotFoundPage;
